export default class Utils {
  /** are we dealing with the client side or the server side*/
  static isClient() {
    return typeof window != "undefined" && window.document ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/libs/utils.js